export default {
      id: "reports_statistics-usage",
      viewBox: "0 0 54 51",
      url: __webpack_public_path__ + "img/icons.svg#reports_statistics",
      toString: function () {
        return this.url;
      }
    }